import React, { useEffect } from 'react';

const FAQSchema = ({ faqs }) => {
  useEffect(() => {
    if (!faqs || faqs.length === 0) return;

    // Remove existing FAQ schema if any
    const existingSchema = document.querySelector('script[type="application/ld+json"][data-faq-schema]');
    if (existingSchema) {
      existingSchema.remove();
    }

    const faqSchema = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": faqs.map(faq => ({
        "@type": "Question",
        "name": faq.question,
        "acceptedAnswer": {
          "@type": "Answer",
          "text": faq.answer
        }
      }))
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.setAttribute('data-faq-schema', 'true');
    script.textContent = JSON.stringify(faqSchema);
    document.head.appendChild(script);

    return () => {
      if (existingSchema) {
        existingSchema.remove();
      }
    };
  }, [faqs]);

  return null;
};

export default FAQSchema;

